import i18n from "../util/i18n.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

const shouldUseAgeAtDeath = (age: number, ageAtDeath: number | null) =>
	ageAtDeath !== null && age >= ageAtDeath;

const AgeAtDeath = ({
	age,
	ageAtDeath,
}: {
	age: number;
	ageAtDeath: number | null;
}) => {
	if (shouldUseAgeAtDeath(age, ageAtDeath)) {
		return (
			<MobileTooltip
				title={i18n.t("common.diedAtAge", {
					ns: "ui",
					defaultValue: "Died at age {{age}}",
					age: ageAtDeath,
				})}
			>
				<span>{ageAtDeath}*</span>
			</MobileTooltip>
		);
	}

	return age;
};

export default AgeAtDeath;

export const wrappedAgeAtDeath = (age: number, ageAtDeath: number | null) => {
	const searchSortValue = shouldUseAgeAtDeath(age, ageAtDeath)
		? ageAtDeath
		: age;

	return {
		value: <AgeAtDeath age={age} ageAtDeath={ageAtDeath} />,
		sortValue: searchSortValue,
		searchValue: searchSortValue,
	};
};
